"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{Overlay as a}from"./src/Overlay.js";e("sp-overlay",a);
//# sourceMappingURL=sp-overlay.js.map
